export default {
  vesselInfo: null,
  maneuveringVersion: null,
  engineVersion: null,
  channelMaster: null,
  alertVersion: null,
  ownVessels: null
};
